<template>
  <div
    v-if="ready"
  >
    <div v-if="!redactCity && !redactMayor && !redactState">
      <div class="message">
        <p class="message-body">
          Select one or more forms above and the corresponding Official's Category that you would like to publish without redacting.
        </p>
      </div>
    </div>
    <div v-else>
      <div class="columns is-multiline">
        <div class="column">
          <div class="message">
            <p class="message-body">
              <checkbox
                v-model="publishWithoutRedaction"
                :value="true"
              >
                Check this box to publish the selected forms above without needing to redact them.
              </checkbox>
            </p>
          </div>
          <div class="message is-warning">
            <div class="message-body">
              <b>Attention:</b> A published form and a redacted form are one and the same. New uploads of the same form will overwrite the existing file whether fields have been redacted or not.
            </div>
          </div>
          <div class="has-text-centered">
            <button
              id="modal-redact-btn"
              type="button"
              class="button is-primary"
              :class="isSaving ? 'is-loading' : ''"
              @click.prevent="publish"
            >
              Publish
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { pdfData } from '@/mixins/pdfData';
import Checkbox from '@/components/phila-ui/CheckboxAdv';

export default {
  name: 'ElectronicRedactions',
  components: {
    Checkbox,
  },
  mixins: [
    pdfData,
  ],
  props: {
    filingId: {
      type: Number,
      required: true,
    },
    cityOfficialsCategory: {
      type: String,
      required: true,
    },
    stateOfficialsCategory: {
      type: String,
      required: true,
    },
    mayorOfficialsCategory: {
      type: String,
      required: true,
    },
    redactCity: {
      type: Boolean,
      required: true,
    },
    redactState: {
      type: Boolean,
      required: true,
    },
    redactMayor: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isSaving: false,
      isDeletingCity: false,
      isDeletingState: false,
      isDeletingMayor: false,
      ready: false,
      publishWithoutRedaction: false,
    };
  },
  computed: {
    filing () {
      return this.$store.state.filing.filing;
    },
  },
  async created () {
    await this.initialFetch();
    this.ready = true;
  },
  methods: {
    async initialFetch () {
      let promises = [];
      await this.$store.commit('filing/setCurrentFilingId', this.filingId);
      promises.push(await this.$store.dispatch('filing/fetchFiling'));
      await Promise.all(promises);
    },
    async publish () {

      this.isSaving = true;
      let cityFormData = null;
      let stateFormData = null;
      let mayorFormData = null;

      if (!this.publishWithoutRedaction) {
        this.isSaving = false;
        return this.$warning('You must agree to the publish statement before proceeding.');
      }

      if (!this.redactCity && !this.redactState && !this.redactMayor) {
        this.isSaving = false;
        return this.$warning('Please select a form type and corresponding Official\'s Category');
      }

      if (this.redactCity) {
        if (!this.cityOfficialsCategory) {
          this.isSaving = false;
          return this.$warning('Please select a Official\'s Category');
        }
        cityFormData = await this.pdf_getPdfData('City', this.filing.id);
        cityFormData.officialsCategory = this.cityOfficialsCategory;
      }

      if (this.redactState) {
        if (!this.stateOfficialsCategory) {
          this.isSaving = false;
          return this.$warning('Please select a Official\'s Category');
        }
        stateFormData = await this.pdf_getPdfData('State', this.filing.id);
        stateFormData.officialsCategory = this.stateOfficialsCategory;
      }

      if (this.redactMayor) {
        if (!this.mayorOfficialsCategory) {
          this.isSaving = false;
          return this.$warning('Please select a Official\'s Category');
        }
        mayorFormData = await this.pdf_getPdfData('Mayor', this.filing.id);
        mayorFormData.officialsCategory = this.mayorOfficialsCategory;
      }

      let pdfPromises = [];

      if (cityFormData) {
        pdfPromises.push(this.$store.dispatch('filing/publishFiling', cityFormData));
      }
      if (stateFormData) {
        pdfPromises.push(this.$store.dispatch('filing/publishFiling', stateFormData));
      }
      if (mayorFormData) {
        pdfPromises.push(this.$store.dispatch('filing/publishFiling', mayorFormData));
      }

      Promise.all(pdfPromises).then(async() => {
        this.$success('Publishing completed.');
        this.isSaving = false;
        this.$emit('redactionCompleted', true);
      });

    },
  },
};
</script>
<style lang="scss" scoped>
  .redact-lists {
    li {
      margin: 3px 0;
      ul.redact-lists {
        margin-bottom: 20px;
      }
    }
  }
</style>
